var _path, _mask, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0002 4.17857C75.2019 4.17857 95.8216 24.7982 95.8216 50C95.8216 75.2018 75.2019 95.8214 50.0002 95.8214C24.7984 95.8214 4.17873 75.2018 4.17873 50C4.17873 24.7982 24.7984 4.17857 50.0002 4.17857ZM50 0C22.2917 0 0 22.2917 0 50C0 77.7083 22.2917 100 50 100C77.7083 100 100 77.7083 100 50C100 22.2917 77.7083 0 50 0Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0002 4.17857C75.2019 4.17857 95.8216 24.7982 95.8216 50C95.8216 75.2018 75.2019 95.8214 50.0002 95.8214C24.7984 95.8214 4.17873 75.2018 4.17873 50C4.17873 24.7982 24.7984 4.17857 50.0002 4.17857ZM50 0C22.2917 0 0 22.2917 0 50C0 77.7083 22.2917 100 50 100C77.7083 100 100 77.7083 100 50C100 22.2917 77.7083 0 50 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2083 18.75C49.9999 18.75 49.9999 18.75 50.2083 18.75C49.9999 18.75 49.9999 18.75 50.2083 18.75C49.9999 18.75 49.9999 18.75 50.2083 18.75C39.5833 18.75 30.8333 27.2917 30.8333 37.5C30.8333 44.1667 34.3749 49.5833 34.5833 49.7917C37.0833 53.9583 39.7916 59.1667 39.7916 60.4167V66.6667V66.875V67.0833L41.8749 79.5833C42.0833 80.625 42.9166 81.25 43.9583 81.25H56.4583C57.4999 81.25 58.3333 80.4167 58.5416 79.5833L60.6249 67.0833V66.875V66.6667V60.4167C60.6249 59.1667 63.3333 53.75 65.8333 49.7917C66.0416 49.5833 69.7916 44.1667 69.7916 37.5C69.5833 27.2917 60.6249 18.75 50.2083 18.75ZM54.583 77.0833H45.6247L44.1663 68.75H55.833L54.583 77.0833ZM62.2913 47.5C60.833 49.5833 56.2497 57.0833 56.2497 60.4167V64.5833H52.083V48.75L55.6247 45.2083C56.458 44.375 56.458 43.125 55.6247 42.2917C54.7913 41.4583 53.5413 41.4583 52.708 42.2917L49.9997 45L47.2913 42.2917C46.458 41.4583 45.208 41.4583 44.3747 42.2917C43.5413 43.125 43.5413 44.375 44.3747 45.2083L47.9163 48.5417V64.5833H43.7497V60.4167C43.7497 57.2917 39.3747 49.7917 37.9163 47.5C37.9163 47.5 34.7913 42.9167 34.7913 37.5C34.7913 29.5833 41.6663 23.125 49.9997 22.9167C58.333 22.9167 65.208 29.5833 65.208 37.5C65.4163 42.7083 62.2913 47.2917 62.2913 47.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscSupport);
export default __webpack_public_path__ + "static/media/ESC-support.0c8893c3585cba80948f1e883d8e2d30.svg";
export { ForwardRef as ReactComponent };